import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Component, forwardRef, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PatientEditInfo, SexFilter, DocumentTypeFilter, PatientSearch } from '../../../../model/patient';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { PatientService } from '../../../../services/patient.service';
import { CacheFilterService } from 'src/app/services/cache/cache-filter.service';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { CountryFilter } from '../../../../model/geography/country-filter';
import { LocalityFilter } from '../../../../model/geography/locality-filter';
import { ProvinceFilter } from '../../../../model/geography/province-filter';
import { GeographyService } from '../../../../services/geography.service';
import { ValidateAutoCompleteSelect } from 'src/app/validators/autocomplete-select.validator';
import { Debounce } from '../../../../decorator/debounce.decorator';
import { CellphoneValidator } from 'src/app/validators/cellphone.validator';
import { patientValidator } from 'src/app/validators/patient/patient.validator';
import { RelevancePatientFilter } from '../../../../model/patient/relevance-patient-filter';
import { AuthService } from '../../../../services/auth.service';
import { Entity, Plan } from 'src/app/model/entity';
import { EntityService } from '../../../../services/entity.service';
import { AliquotTaxService } from '../../../../services/aliquot-tax/aliquot-tax.service';
import { PracticeService } from '../../../../services/practice.service';
import { PracticeRegion } from '../../../../model/practice-region';
import { PracticeRegionFilter } from 'src/app/model/practice-region-filter';
import { AliquotTax } from '../../../../model/aliquot-tax';
import { PhysicianService } from '../../../../services/physician.service';
import { PhysicianFilter } from '../../../../model/physician-Filter';
import { DiagnosticFilter } from '../../../../model/diagnostic-filter';
import { DiagnosticService } from '../../../../services/diagnostic.service';
import { AdressCPValidator } from 'src/app/validators/adress-cp.validator';

@Component({
  selector: 'app-patient-edit',
  templateUrl: './patient-edit-control.component.html',
  styleUrls: ['./patient-edit-control.component.css']
})
export class PatientEditControlComponent implements OnInit {

  formQr: FormGroup;
  form: FormGroup;
  loadingAction = false;
  loading = false;
  seePatientContactInfo: boolean;
  @Input() patientId?: number;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() document: string;
  patientEditInfo: PatientEditInfo;
  canViewMedicalPatientInfo: boolean;
  isQrEdition: boolean;
  loadingQr = false;

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onClose: EventEmitter<PatientSearch>  = new EventEmitter();
  relevancePatientFilters: RelevancePatientFilter[] = [];
  diagnositicFilters: DiagnosticFilter[] = [];
  patientRelevancePatient: RelevancePatientFilter[] = [];
  filterCompleteSexFilter: FilterCompleteService<SexFilter>;
  filterCompleteDocumentTypeFilter: FilterCompleteService<DocumentTypeFilter>;
  filterCompleteCountryFilter: FilterCompleteService<CountryFilter>;
  filterCompleteLocalityFilter: FilterCompleteService<LocalityFilter>;
  filterCompleteProvinceFilter: FilterCompleteService<ProvinceFilter>;
  filterCompleteAliquotsTax: FilterCompleteService<AliquotTax>;
  filterCompleteEntities: FilterCompleteService<Entity>;
  filterCompletePlans: FilterCompleteService<Plan>;
  filterCompleteDiagnostic: FilterCompleteService<DiagnosticFilter>;
  @ViewChild('inputQr', { static: false }) inputQr: ElementRef;
  freeDiagnostic: string;
  isReceptionSector: boolean;


  constructor(private notificationToastService: NotificationToastService
    , private cacheFilterService: CacheFilterService
    , private diagnosticService: DiagnosticService
    , private formBuilder: FormBuilder
    , private entityService: EntityService
    , private aliquotTaxService: AliquotTaxService
    , private authService: AuthService
    , private geographyService: GeographyService
    , private patientService: PatientService) {

      this.isReceptionSector = this.authService.isReceptionSector();
      this.seePatientContactInfo = this.authService.seePatientContactInfo();

      this.formQr = this.formBuilder.group({
        Qr: ['', [Validators.required]],
      });

      this.form = this.formBuilder.group({
        DocumentType: ['', [Validators.required, ValidateAutoCompleteSelect]],
        Number: ['' ],
        LastName: ['', [Validators.required]],
        FirstName: ['', [Validators.required]],
        Pid: [''],
        CredentialNumber: [''],
        BirthDate: ['', [Validators.required]],
        Sex: ['', [Validators.required, ValidateAutoCompleteSelect]],
        Relevances: [''],
        Diagnostics:[''],
        Country: [''],
        InAutoGestion: [''],
        ViewResultWeb: [ true ],
        Province: [''],
        Locality: [''],
        AddressStreet: [''],
        AddressNumber: [''],
        AddressCP: ['', [new AdressCPValidator()]],
        Floor: [''],
        AddressDpto: [''],
        PersonalPhone: [''],
        LaborPhone: [''],
        EmergencyPhone: [''],
        AcceptConfirm: [ true ],
        CellPhone: ['', [new CellphoneValidator()]],
        Email: ['', [Validators.email]],
        Weight: [''],
        Height: [''],
        Qr: [''],
        Claustrophobia: [''],
        Pacemaker: [''],
        MetallicPart: [''],
        DisabilityPermanent: [''],
        DisabilityTemporal: [''],
        CreateDate: [''],
        CreateUser: [''],
        UpdateDate: [''],
        UpdateUser: [''],
        OriginalEntityValue: [''],
        MotherFirstName: [''],
        MotherLastName: [''],
        FatherFirstName: [''],
        FatherLastName: [''],
        Entity: [''],
        Plan: [''],
        AliquotTax: [''],
        Physicians: [ [] ],
        CoordinatorPhysician: [''],
        PracticeRegion: [''],
        FreeDiagnostic: [''],
        Id: [''],
        IsReceptionSector: [this.isReceptionSector],
      }, { validator: patientValidator.bind(this) });

      this.subscribeChanges();

      this.filterCompleteEntities =
        new FilterCompleteService<Entity>([], this.form.controls.Entity);

      this.filterCompletePlans =
        new FilterCompleteService<Plan>([], this.form.controls.Plan);

      this.filterCompleteSexFilter =
        new FilterCompleteService<SexFilter>([], this.form.controls.Sex);

      this.filterCompleteAliquotsTax =
        new FilterCompleteService<AliquotTax>([], this.form.controls.AliquotTax);

      this.filterCompleteDocumentTypeFilter =
        new FilterCompleteService<DocumentTypeFilter>([], this.form.controls.DocumentType);

      this.filterCompleteCountryFilter =
        new FilterCompleteService<CountryFilter>([], this.form.controls.Country);

      this.filterCompleteLocalityFilter =
        new FilterCompleteService<LocalityFilter>([], this.form.controls.Locality);

      this.filterCompleteProvinceFilter =
        new FilterCompleteService<ProvinceFilter>([], this.form.controls.Province);
    }

    async saveQr()  {
      if (this.formQr.valid && this.loadingQr === false) {
        try {

          this.form.patchValue({
            Qr: this.formQr.controls.Qr.value
          });

          this.loadingQr = true;
          const qrInfo = await this.patientService.getPatientQrInfo(this.formQr.controls.Qr.value);

          this.form.patchValue({
            Number: qrInfo.Number,
            LastName: qrInfo.LastName,
            FirstName: qrInfo.FirstName,
            BirthDate: qrInfo.BirthDate,
            DocumentType: qrInfo.DocumentType,
            Sex: qrInfo.SexFilter
          });
        } catch (err) {
          console.log(err);
          this.notificationToastService.error(JSON.stringify(err.error), 'QR de pacientes');
        } finally {
          this.loadingQr = false;
          this.isQrEdition = false;
        }
      }
    }

    deleteQr() {
      this.formQr.controls.Qr.setValue('');
      this.form.patchValue({
        Qr: null
      });
      this.inputQr.nativeElement.focus();
    }

    cancelQr() {
      this.isQrEdition = false;
    }

  private subscribeChanges() {

    this.form.controls.Entity.valueChanges.subscribe(() => {
      if (this.form.controls.Entity.value &&
        this.form.controls.Entity.value.Id) {
        this.entityService.getPlansByEntityId(this.form.controls.Entity.value.Id)
          .then(plans => {
            this.filterCompletePlans = new FilterCompleteService<Plan>(
              plans, this.form.controls.Plan);
            if (this.patientEditInfo && this.patientEditInfo.Plan) {
              const plan = plans.find(e => e.Id ===
                this.patientEditInfo.Plan.Id);
              this.form.patchValue({ Plan: plan });
            } else {
              this.form.patchValue({ Plan: null });
            }
          });
      } else {
        this.filterCompletePlans = new FilterCompleteService<Plan>(
          [], this.form.controls.Plan);
        this.form.patchValue({ Plan: null });
      }
    });

    this.form.controls.Plan.valueChanges.subscribe(() => {
      if (this.form.controls.Plan.value &&
        this.form.controls.Plan.value.Id) {
        this.aliquotTaxService.getAliquotsTaxByPlanId(this.form.controls.Plan.value.Id)
          .then(alicuots => {
            this.filterCompleteAliquotsTax = new FilterCompleteService<AliquotTax>(
              alicuots, this.form.controls.AliquotTax);
            if (this.patientEditInfo &&
                this.patientEditInfo.AliquotTax) {
              const aliquotTax = alicuots.find(e => e.Id ===
                this.patientEditInfo.AliquotTax.Id);
              this.form.patchValue({ AliquotTax: aliquotTax });
            } else {
              this.form.patchValue({ AliquotTax: null });
            }
          });
      } else {
        this.filterCompleteAliquotsTax = new FilterCompleteService<AliquotTax>(
          [], this.form.controls.AliquotTax);
        this.form.patchValue({ AliquotTax: null });
      }
    });

  }

  get isValid() {
    return this.form && this.form.valid; }

  get filterCompleteDiagnosticFilterOptions() { return this.filterCompleteDiagnostic ?
      this.filterCompleteDiagnostic.filteredOptions : []; }
  get filterCompleteSexFilterOptions() { return this.filterCompleteSexFilter ?
    this.filterCompleteSexFilter.filteredOptions : []; }
  get filterCompleteDocumentTypeFilterOptions() { return this.filterCompleteDocumentTypeFilter ?
      this.filterCompleteDocumentTypeFilter.filteredOptions : []; }
  get filterCompleteCountryFilterOptions() { return this.filterCompleteCountryFilter ?
      this.filterCompleteCountryFilter.filteredOptions : []; }
  get filterCompleteLocalityFilterOptions() { return this.filterCompleteLocalityFilter ?
      this.filterCompleteLocalityFilter.filteredOptions : []; }
  get filterCompleteProvinceFilterOptions() { return this.filterCompleteProvinceFilter ?
      this.filterCompleteProvinceFilter.filteredOptions : []; }
  get filteredEntitiesOptions() { return this.filterCompleteEntities ?
      this.filterCompleteEntities.filteredOptions : []; }
  get filteredPlansOptions() { return this.filterCompletePlans ?
      this.filterCompletePlans.filteredOptions : []; }
  get filteredAliquotsTaxOptions() { return this.filterCompleteAliquotsTax ?
      this.filterCompleteAliquotsTax.filteredOptions : []; }
  get f() { return this.form.controls; }

  getPatientEditInfo(): PatientEditInfo {
   if (this.form) {
    return  <PatientEditInfo>this.form.getRawValue();
   } else { return null; }
  }

  async ngOnInit() {
    try {
      this.loading = true;

      this.authService.canViewMedicalPatientInfo()
        .then(value => {
          this.canViewMedicalPatientInfo = value;
        });

        if (this.patientId) {
          this.isQrEdition = false;
        } else if (this.authService.getSectorScannDocument()) {
          this.isQrEdition = true;
        }

      this.relevancePatientFilters = await this.cacheFilterService.getRelevancePatientFilters();
      this.diagnositicFilters = await this.diagnosticService.getDiagnosticsFilter();
      this.diagnositicFilters = this.diagnositicFilters.filter(d => d.CodeMode);

      if (this.patientId) {

        this.patientEditInfo = await this.patientService.getPatientEditInfo(this.patientId);

        const relevancePatientFilterExists: RelevancePatientFilter[] = [];
        const diagnosticFilterExists:DiagnosticFilter[] = [];

        this.relevancePatientFilters.forEach((relevancePatientFilter) => {
          if (this.patientEditInfo.Relevances.findIndex(i => i.Id === relevancePatientFilter.Id) > -1) {
            relevancePatientFilterExists.push(relevancePatientFilter);
          }
        });

        this.diagnositicFilters.forEach((diagnosticFilter) => {
          if (this.patientEditInfo.Diagnostics.findIndex(i => i.Id === diagnosticFilter.Id) > -1) {
            diagnosticFilterExists.push(diagnosticFilter);
          }
        });

          if (this.patientEditInfo) {

          this.form.patchValue({
            DocumentType: this.patientEditInfo.DocumentType,
            Number: this.patientEditInfo.Number,
            LastName: this.patientEditInfo.LastName,
            CredentialNumber: this.patientEditInfo.CredentialNumber,
            FirstName: this.patientEditInfo.FirstName,
            Pid: this.patientEditInfo.Id,
            InAutoGestion: this.patientEditInfo.InAutoGestion,
            ViewResultWeb:  this.patientEditInfo.ViewResultWeb,
            BirthDate: this.patientEditInfo.BirthDate,
            Sex: this.patientEditInfo.Sex,
            Diagnostics: diagnosticFilterExists,
            Relevances: relevancePatientFilterExists,
            Country: this.patientEditInfo.Country,
            Province: this.patientEditInfo.Province,
            Locality: this.patientEditInfo.Locality,
            AddressStreet: this.patientEditInfo.AddressStreet,
            AddressNumber: this.patientEditInfo.AddressNumber,
            AddressCP: this.patientEditInfo.AddressCP,
            Floor: this.patientEditInfo.Floor,
            AddressDpto: this.patientEditInfo.AddressDpto,
            PersonalPhone: this.patientEditInfo.PersonalPhone,
            LaborPhone: this.patientEditInfo.LaborPhone,
            EmergencyPhone: this.patientEditInfo.EmergencyPhone,
            AcceptConfirm: this.patientEditInfo.AcceptConfirm,
            CellPhone: this.patientEditInfo.CellPhone,
            OriginalEntityValue: this.patientEditInfo.OriginalEntityValue,
            Email: this.patientEditInfo.Email,
            Weight: this.patientEditInfo.Weight,
            Height: this.patientEditInfo.Height,
            Claustrophobia: this.patientEditInfo.Claustrophobia,
            Pacemaker: this.patientEditInfo.Pacemaker,
            MetallicPart: this.patientEditInfo.MetallicPart,
            DisabilityPermanent: this.patientEditInfo.DisabilityPermanent,
            DisabilityTemporal: this.patientEditInfo.DisabilityTemporal,
            CreateDate: this.patientEditInfo.CreateDate,
            CreateUser: this.patientEditInfo.CreateUser,
            UpdateDate: this.patientEditInfo.UpdateDate,
            UpdateUser: this.patientEditInfo.UpdateUser,
            MotherFirstName: this.patientEditInfo.MotherFirstName,
            MotherLastName: this.patientEditInfo.MotherLastName,
            FatherFirstName: this.patientEditInfo.FatherFirstName,
            FatherLastName: this.patientEditInfo.FatherLastName,
            FreeDiagnostic: this.patientEditInfo.FreeDiagnostic,
            Id: this.patientEditInfo.Id,
          });

          this.freeDiagnostic = this.patientEditInfo.FreeDiagnostic;
        }
      } else {
        this.form.patchValue({
          Number: this.document,
          LastName: this.lastName,
          FirstName: this.firstName
        });
      }

      // cargo los combos
      this.loadFiltersComplete();



    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err.error), 'Edición de pacientes');
    } finally {
      this.loading = false;
    }
  }


  freeDiagnosticChange(event: string) {
    console.log(event);
    this.form.patchValue({ FreeDiagnostic: event });
  }

  private loadFiltersComplete(): void {

    this.cacheFilterService.getSexFilters().then((sexFilters) => {
      this.filterCompleteSexFilter = new FilterCompleteService<SexFilter>(
        sexFilters, this.form.controls.Sex);
    });

    this.cacheFilterService.getDocumentTypeFilters().then((documentTypeFilters) => {
      this.filterCompleteDocumentTypeFilter = new FilterCompleteService<DocumentTypeFilter>(
        documentTypeFilters, this.form.controls.DocumentType);
    });

    this.cacheFilterService.getCountryFilters().then((countryFilters) => {
      this.filterCompleteCountryFilter = new FilterCompleteService<CountryFilter>(
        countryFilters, this.form.controls.Country);
    });

    this.entityService.getEntities(true).then((entities) => {
      this.filterCompleteEntities = new FilterCompleteService<Entity>(
        entities, this.form.controls.Entity);
      if (this.patientEditInfo.Plan) {
        const entity = entities.find(e => e.Id === this.patientEditInfo.Plan.EntityId);
        this.form.patchValue({ Entity: entity });
      }
    });

    if (this.form.controls.Country.value) {this.loadProvinceFilters(); }
  }

  private loadProvinceFilters(): void {
    if (this.form.controls.Country.value) {
      this.geographyService.getProvinceFilters(this.form.controls.Country.value.Id, '').then((provinceFilters) => {
        this.filterCompleteProvinceFilter = new FilterCompleteService<ProvinceFilter>(
          provinceFilters, this.form.controls.Province);
      });
    }
  }

  @Debounce(600)
  onLocalityChange(value: string): void {
    if (this.form.controls.Province.value) {
      this.geographyService.getLocalityFilters(this.form.controls.Province.value.Id, value).then((localityFilters) => {
        this.filterCompleteLocalityFilter = new FilterCompleteService<LocalityFilter>(
          localityFilters, this.form.controls.Locality);
      });
    }
  }

  onProvinceChange(): void {
    this.form.patchValue({ Locality: null });
  }

  provinceSelected(province: ProvinceFilter) {
    this.form.patchValue({ Province: province, Locality: null });
  }

  onCountryChange(): void {
    this.form.patchValue({ Province: null, Locality: null });
  }

  onEntityChange(): void {

  }

  countrySelected(country: CountryFilter) {
    this.form.patchValue({ Country: country, Province: null, Locality: null });
    this.loadProvinceFilters();
  }

  close(): void {
    this.onClose.emit(null);
  }

  async save() {
    if (this.isValid) {
      try {
        this.loadingAction = true;
        const patientEditInfo = this.getPatientEditInfo();

        if ( this.authService.addAutomaticPhysicianInPatient &&
             this.authService.getPhysicianId()) {
          patientEditInfo.AddAutomaticPhysicianInPatient = true;
          patientEditInfo.PhysicianId = this.authService.getPhysicianId();
        }


        const patientId = await this.patientService.patientUpdate(patientEditInfo);
        const patientSearch = new PatientSearch();
        patientSearch.Id = patientId;
        patientSearch.FirstName = patientEditInfo.FirstName;
        patientSearch.LastName = patientEditInfo.LastName;
        this.onClose.emit(patientSearch);
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Edición de pacientes');
      } finally {
        this.loadingAction = false;
      }
    }
  }

}
